export class ItsTheFinalCountdown {
  countdownSeconds = 0;
  attemptsCounter = 4;
  countdownInterval: NodeJS.Timeout | null = null;
}

export const SUCCESS_TEXT_NOTIFICATIONS = {
  send: {
    whatsapp: 'RESEND_WHATSAPP_CODE_SUCCESS',
    sms: 'RESEND_SMS_CODE_SUCCESS',
  },
  change: {
    whatsapp: 'SET_NEW_WHATSAPP_VERIFICATION_METHOD_SUCCESS',
    sms: 'SET_NEW_SMS_VERIFICATION_METHOD_SUCCESS',
  },
};
